<app-menu class="menuApp" xmlns="http://www.w3.org/1999/html"></app-menu>
<div class="main">
  <div style="padding-top: 2vh; height: 100%; width: 85%; margin: auto">

    <div class="row" style="height: 10%">
      <div class="col-4">
        <h1 class="centerVert textM" style="text-align: right">{{this.localiser.get("thresholds.selectSensor")}}</h1>
      </div>

      <div class="col-8" style="margin-top: 1vh">
        <mat-form-field style="width: 90%" class="centerVert" appearance="fill">
          <mat-label>{{this.localiser.get("fade.sensor")}}</mat-label>
          <mat-select class="textS+" (ngModelChange)="selectSensor($event)" [(ngModel)]="sensorSelect">
            <mat-option *ngFor="let sensor of sensores" [value]="sensor">{{sensor.nombre}} ({{sensor.idLuminaria}})</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

    </div>

    <div class="row boxBack" style="height: 10%; text-align: center; margin-top: 2%">
      <div *ngIf="!sensorSelect" style="display: flex; width: 100%; margin: auto;">
        <div class="col-8">
          <h1 class="textM" style="margin: auto 3% auto auto">{{this.localiser.get("devices.name")}}: --</h1>
        </div>
        <div class="col-4">
          <h1 class="textM" style="margin: auto auto auto 3%">ID: --</h1>
        </div>
      </div>
      <div *ngIf="sensorSelect" style="display: flex; width: 100%; margin: auto;">
        <div class="col-8">
          <h1 class="textM" style="margin: auto 3% auto auto">{{this.localiser.get("devices.name")}}:
            <input type="text" style="border: 1px; background: rgba(255, 255, 255, 0.1); color: white; width: 70%" [(ngModel)]="nombre" maxlength="50"></h1>
        </div>
        <div class="col-4">
          <h1 class="textM" style="margin: auto auto auto 3%">ID: {{sensorSelect.idLuminaria}}</h1>
        </div>
      </div>
    </div>

    <div class="row" style="height: 70%; padding-top: 2%">
      <div class="col">

        <div class="row textS+" style="min-height: 30%; width: 100%; padding-top: 1%">

          <div class="col-4">
            <div class="centerVert">
              <div class="row" style="margin: auto; width: 100%">
                <h1 class="marginAuto textM">{{this.localiser.get("thresholds.measure")}}</h1>
              </div>
              <div class="row">
                <input class="marginAuto" style="width: 50%" type="text" [(ngModel)]="unidadMedida" maxlength="12" [disabled]="!hasSensorSelected">
              </div>
            </div>
          </div>

          <div class="col-8" style="text-align: left">
            <label class="textM" style="display: block">{{this.localiser.get("floorplans.description")}}</label>
            <textarea class="marginAuto textS+" style="width: 80%" placeholder="{{this.localiser.get('floorplans.description')}}" [(ngModel)]="descripcion" maxlength="300" [disabled]="!hasSensorSelected"></textarea>
          </div>

        </div>

        <div class="row" style="margin: auto; width: 100%; height: 15%; margin-top: 1%">
          <div class="col" style="display: flex">
            <h1 class="textS+" style="margin: auto 0">
              {{this.localiser.get('thresholds.4mAEquivalence')}}:
              <input (input)="maxLengthCheckEq4($event)" class="textS+" style="width: 25%; margin: auto 0;" type="number" [(ngModel)]="equivalencia4mA" max="9999999" [disabled]="!hasSensorSelected">
              {{unidadMedida}}
            </h1>
          </div>

          <div class="col" style="display: flex">
            <h1 class="textS+" style="margin: auto 0">
              {{this.localiser.get('thresholds.lowerThreshold')}}:
              <input [disabled]="!hasSensorSelected || !enabledUmbralBajo" (input)="maxLengthCheckUmbralBajo($event)" class="textS+" style="width: 25%; margin: auto 0;" type="number" [(ngModel)]="umbralBajo" max="9999999">
              {{unidadMedida}}
            </h1>
          </div>

          <div class="col-2" style="display: flex; margin: auto;">
            <mat-checkbox [(ngModel)]="enabledUmbralBajo" [disabled]="!hasSensorSelected">
              <h1 class="textS marginAuto" style="white-space: break-spaces">Enabled lower threshold</h1>
            </mat-checkbox>
          </div>

        </div>
        <div class="row" style="margin: auto; width: 100%; height: 15%">

          <div class="col" style="display: flex">
            <h1 class="textS+" style="margin: auto 0">
              {{this.localiser.get('thresholds.20mAEquivalence')}}:
              <input (input)="maxLengthCheckEq20($event)" class="textS+" style="width: 25%; margin: auto 0;" type="number" [(ngModel)]="equivalencia20mA" max="9999999" [disabled]="!hasSensorSelected">
              {{unidadMedida}}
            </h1>
          </div>

          <div class="col" style="display: flex">
            <h1 class="textS+" style="margin: auto 0">
              {{this.localiser.get('thresholds.upperThreshold')}}:
              <input [disabled]="!hasSensorSelected || !enabledUmbralAlto" (input)="maxLengthCheckUmbralAlto($event)" class="textS+" style="width: 25%; margin: auto 0;" type="number" [(ngModel)]="umbralAlto" max="9999999">
              {{unidadMedida}}
            </h1>
          </div>

          <div class="col-2" style="display: flex; margin: auto;">
            <mat-checkbox [(ngModel)]="enabledUmbralAlto" [disabled]="!hasSensorSelected">
              <h1 class="textS marginAuto" style="white-space: break-spaces">Enabled upper threshold</h1>
            </mat-checkbox>
          </div>

        </div>

        <div class="row" style="margin: auto; text-align: center; width: 100%; height: 15%; margin-top: 3%; padding-right: 15%">
          <!-- <button *ngIf="!actualizado" style="margin: auto; padding: 20px" class="customButtonColorReverse textS+" mat-button (click)="updateSensorInfo()" [disabled]="!hasSensorSelected">
            {{this.localiser.get('button.update')}}
          </button>
          <button *ngIf="actualizado" style="margin: auto; padding: 20px" class="customButtonColorDone textS+" mat-button (click)="updateSensorInfo()" [disabled]="!hasSensorSelected">
            {{this.localiser.get('button.updated')}}
            <span class="material-icons-outlined marginAuto">done</span>
          </button> -->
          <button *ngIf="!actualizado" style="margin: auto; padding: 20px" class="customButtonColorReverse textS+" mat-button (click)="updateSensorInfo()">
            {{this.localiser.get('button.update')}}
          </button>
          <button *ngIf="actualizado" style="margin: auto; padding: 20px" class="customButtonColorDone textS+" mat-button (click)="updateSensorInfo()">
            {{this.localiser.get('button.updated')}}
            <span class="material-icons-outlined marginAuto">done</span>
          </button>
        </div>

      </div>
    </div>

  </div>

</div>
